export default __webpack_public_path__ + "static/media/refresh.a8933df8.svg";